var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isStatusLoading
    ? _c("LoadingAnimation", { attrs: { "animation-style": "bars" } })
    : _c("div", { staticClass: "w-100 user-modal-choose-payment-view px-4" }, [
        _vm.isLegacy() === true
          ? _c("div", { staticStyle: { "max-width": "607px" } }, [
              _c(
                "div",
                {
                  staticClass:
                    "alert alert-warning gap-10 d-flex flex-column align-items-center p-5",
                },
                [
                  _c("p", { staticClass: "font-size-sm-200" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "You're still on a legacy subscription plan"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "font-size-sm-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          'Your legacy subscription does not allow to buy "Pay As You Go" Credits.'
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "font-size-sm-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Please contact our support team to cancel your legacy subscription now and get a partial refund."
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "font-size-sm-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          'You can then choose one of our new subscription plans and get additional "Pay As You Go" Credits as needed.'
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg contact-btn",
                      on: { click: _vm.openContactSupport },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("trans")("Contact support"))),
                      ]),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isLegacy() === false
          ? _c(
              "div",
              [
                !_vm.showWeekPass
                  ? _c("div", { staticClass: "mb-5 text-center" }, [
                      _c(
                        "p",
                        { staticClass: "font-weight-bold font-size-200 mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.titleText) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isTrialEnabled
                  ? _c("TrialInfoGraphic", {
                      staticClass: "mb-4",
                      attrs: {
                        "count-days-free-trial-duration":
                          _vm.trialData.countDaysFreeTrialDuration,
                        "count-days-reminder-before-trial-end":
                          _vm.trialData.countDaysReminderBeforeTrialEnd,
                        "date-first-charge-full":
                          _vm.trialData.dateFirstChargeFull,
                        "date-first-charge-short":
                          _vm.trialData.dateFirstChargeShort,
                        "price-at-trial-start":
                          _vm.trialData.priceAtTrialStart[_vm.currency],
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOc
                  ? _c("SelectFileSize", {
                      staticClass: "mb-5",
                      attrs: { disabled: _vm.isSubmitting },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isApi2Convert
                  ? _c("SelectConversionMinutes", {
                      staticClass: "mb-5",
                      attrs: { disabled: _vm.isSubmitting },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCreditModal
                  ? _c("SelectCredits", {
                      staticClass: "mb-5",
                      attrs: { disabled: _vm.isSubmitting },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isApi2Convert && !_vm.isCreditModal
                  ? _c("SelectBilling", {
                      attrs: {
                        disabled: _vm.isSubmitting,
                        "absolute-file-size-limit":
                          _vm.largestPurchasableFileSize,
                        "trial-data": _vm.trialData,
                        currency: _vm.currency,
                        "selected-size": _vm.selectedSize,
                        "selected-provider": _vm.selectedProvider,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", {
                  staticClass: "mb-1 text-center",
                  domProps: { innerHTML: _vm._s(_vm.dueText) },
                }),
                _vm._v(" "),
                !_vm.isCreditModal
                  ? _c("div", { staticClass: "mb-3 text-center" }, [
                      this.selectedProduct === "payg"
                        ? _c("span", { staticClass: "mr-2_" }, [
                            _c("i", {
                              staticClass: "far fa-check text-success mr-1_",
                            }),
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("Credits valid for one year")
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.selectedProduct === "subscription"
                        ? _c("span", { staticClass: "mr-2_" }, [
                            _c("i", {
                              staticClass: "far fa-check text-success mr-1_",
                            }),
                            _vm._v(_vm._s(_vm._f("trans")("Cancel anytime"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _c("i", {
                          staticClass: "far fa-check text-success mr-1_",
                        }),
                        _vm._v(
                          _vm._s(_vm._f("trans")("Full money back guarantee"))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("ButtonWithLoadingState", {
                  staticClass:
                    "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-2",
                  attrs: {
                    "data-user-modal-button-submit": "",
                    icon: "fa fa-arrow-right lh-1",
                    text: _vm.submitButtonText,
                    "is-state-loading": _vm.isSubmitting,
                    disabled: !_vm.productSlug,
                    "show-icon-after-text": true,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToChoosePayment.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showGoBack,
                        expression: "showGoBack",
                      },
                    ],
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "w-100 d-flex justify-content-center align-items-center text-dark font-size-125 cursor-pointer",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.goBack.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-arrow-left lh-1 mr-1 text-uppercase",
                        }),
                        _vm._v(_vm._s(_vm._f("trans")("Back"))),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("Transition", { attrs: { name: "fade-fast" } }, [
                  _vm.showCancelInfo || _vm.showRefundInfo
                    ? _c("div", {
                        staticClass:
                          "position-absolute w-100 h-100 top-0 left-0 bg-modal",
                        staticStyle: {
                          "z-index": "99",
                          "box-shadow": "0 0 2000px 2000px rgb(0 0 0 / 50%)",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.showRefundInfo = false
                            _vm.showCancelInfo = false
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-100 position-relative" },
                  [
                    _c("Transition", { attrs: { name: "fade-grow-slow" } }, [
                      _vm.showRefundInfo
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "border px-4 py-3 bg-white rounded position-absolute w-100 bottom-0 shadow",
                              staticStyle: {
                                "max-width": "404px",
                                "z-index": "100",
                                left: "50%",
                                transform: "translate(-50%, 0)",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-size-125 border-bottom font-weight-bold pb-2 mb-2 position-relative",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm._f("trans")("Refund policy")) +
                                      "\n                    "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cursor-pointer position-absolute top-0 right-0 lh-1 font-size-150",
                                      attrs: {
                                        "data-user-modal-payment-refund-info-close":
                                          "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          _vm.showRefundInfo = false
                                        },
                                      },
                                    },
                                    [_vm._v("×")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "You can request a full refund within 14 days after you subscribed with no questions asked. Please contact our support team for assistance."
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "Please note that you are not eligible for a refund anymore after 14 days."
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("Transition", { attrs: { name: "fade-grow-slow" } }, [
                      _vm.showCancelInfo
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "border px-4 py-3 bg-white rounded position-absolute w-100 bottom-0 shadow",
                              staticStyle: {
                                "max-width": "404px",
                                "z-index": "100",
                                left: "50%",
                                transform: "translate(-50%, 0)",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-size-125 border-bottom font-weight-bold pb-2 mb-2 position-relative",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._f("trans")(
                                          "Cancel the subscription at any time"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cursor-pointer position-absolute top-0 right-0 lh-1 font-size-150",
                                      attrs: {
                                        "data-user-modal-payment-cancel-info-close":
                                          "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          _vm.showCancelInfo = false
                                        },
                                      },
                                    },
                                    [_vm._v("×")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("trans")(
                                      "In order to cancel your subscription, please login and go to your dashboard."
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "You will be able to use the service after cancellation for the amount of time you have already paid for. You can reactivate your subscription later at any time."
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }